var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"software-license-view"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.softwareLicenseText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }